import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { axiosClient } from "../api/config/base";

const useDecodedToken = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [decodedData, setDecodedData] = useState("");

  useEffect(() => {
    const getDecodedToken = async () => {
      try {
        const { data } = await axiosClient.post("/store/decode-token", { token });
        setDecodedData(data?.data);
      } catch (error) {
        console.error(error);
      }
    };

    if (token) {
      getDecodedToken();
    }
  }, [token]);

  return decodedData;
};

export default useDecodedToken;
